"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Reset the redux store to its initialState when the defined action(s) occur
 * @param {object} reducer The top level composed reducer to comprise the redux store
 * @param {object} initialState The initial state of the redux store (will be used to reset)
 * @param {Array} resetOnAction The action or actions to cause the store to reset its state
 * @return {object} The determined state
 */
var _default = exports["default"] = function _default(reducer, initialState, resetOnAction) {
  return function (state, action) {
    // Check if the resetOnAction is a string or array
    var reset = resetOnAction !== undefined && Array.isArray(resetOnAction) ? resetOnAction.includes(action.type) : action.type === resetOnAction;
    var newState = !reset ? state : _objectSpread(_objectSpread({}, initialState), {}, {
      routing: state.routing
    });
    return reducer(newState, action);
  };
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/thunderball-client/lib/render/handleResetOnAction.js
// module id = 3166
// module chunks = 25